import platform from './platform.txt?raw'
import implementationModel from './implementation-model.txt?raw'
import entitiesHierarchiesAssets from './entities-hierarchies-assets.txt?raw'
import mcpActions from './mcp-actions.txt?raw'
import responseFormat from './response-format.txt?raw'

const SECTION_DIVIDER = '\n\n'

export const GLOBAL_ASSISTANT_STATIC_SECTIONS = [
  { id: 'platform', title: 'General platform information', content: platform.trim() },
  { id: 'implementation-model', title: 'Implementation model', content: implementationModel.trim() },
  {
    id: 'entities-hierarchies-assets',
    title: 'Entities, hierarchies, and assets',
    content: entitiesHierarchiesAssets.trim(),
  },
  { id: 'mcp-actions', title: 'MCP server and actions', content: mcpActions.trim() },
  { id: 'response-format', title: 'Response format', content: responseFormat.trim() },
] as const

export const GLOBAL_ASSISTANT_STATIC_PROMPT = GLOBAL_ASSISTANT_STATIC_SECTIONS.map(
  (section) => `## ${section.title}\n${section.content}`
).join(SECTION_DIVIDER)
